
'use client';
import Image from 'next/image';
import Link from 'next/link';

// Partners & Collaborators Section
const PartnersSection = () => {
  const partnerImages = [
    {
      src: "/images/globalblockchainshow-white.svg",
      alt: "global-blockchain-show",
      width: 900,
      height: 400
    },
    {
      src: "/images/global-games-show.svg",
      alt: "global-games-show",
      width: 900,
      height: 400
    }
  ];

  return (
    <section data-component-id="src/app/PartnersSection.tsx:24:4" data-component-path="src/app/PartnersSection.tsx" data-component-line="24" data-component-end-line="57" data-component-file="PartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20bg-bg-surface%22%7D" id="partners" className="w-full bg-bg-surface">
      <div data-component-id="src/app/PartnersSection.tsx:25:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="25" data-component-end-line="56" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1440px%5D%20mx-auto%20px-%5B30px%5D%20sm%3Apx-%5B40px%5D%20lg%3Apx-%5B56px%5D%20py-%5B10px%5D%20sm%3Apy-%5B16px%5D%20lg%3Apy-%5B20px%5D%22%7D" className="w-full max-w-[1440px] mx-auto px-[30px] sm:px-[40px] lg:px-[56px] py-[10px] sm:py-[16px] lg:py-[20px]">
        <div data-component-id="src/app/PartnersSection.tsx:26:8" data-component-path="src/app/PartnersSection.tsx" data-component-line="26" data-component-end-line="55" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B30px%5D%20justify-start%20items-center%20w-full%20max-w-%5B1146px%5D%20mx-auto%20px-%5B10px%5D%20py-%5B10px%5D%22%7D" className="flex flex-col gap-[30px] justify-start items-center w-full max-w-[1146px] mx-auto px-[10px] py-[10px]">
          {/* Section Header */}
          <h2 data-component-id="src/app/PartnersSection.tsx:28:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="28" data-component-end-line="32" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B24px%5D%20sm%3Atext-%5B28px%5D%20lg%3Atext-%5B31px%5D%20font-bold%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20leading-%5B30px%5D%20sm%3Aleading-%5B34px%5D%20lg%3Aleading-%5B37px%5D%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20text-left%20text-text-accent%20font-rubik%22%2C%22textContent%22%3A%22Past%20Partners%20%26%20Collaborators%22%7D" className="text-[24px] sm:text-[28px] lg:text-[31px] font-bold 
                         leading-[30px] sm:leading-[34px] lg:leading-[37px] 
                         text-left text-text-accent font-rubik">
            Past Partners & Collaborators
          </h2>

          {/* Partners Images */}
          <div data-component-id="src/app/PartnersSection.tsx:35:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="35" data-component-end-line="54" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20lg%3Aflex-row%20gap-%5B20px%5D%20sm%3Agap-%5B28px%5D%20lg%3Agap-%5B32px%5D%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20w-full%20justify-center%20items-center%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20px-%5B20px%5D%20sm%3Apx-%5B40px%5D%20lg%3Apx-%5B80px%5D%22%7D" className="flex flex-col lg:flex-row gap-[20px] sm:gap-[28px] lg:gap-[32px] 
                          w-full justify-center items-center 
                          px-[20px] sm:px-[40px] lg:px-[80px]">
            {partnerImages.map((partner, index) => (
              <div data-component-id="src/app/PartnersSection.tsx:39:14" data-component-path="src/app/PartnersSection.tsx" data-component-line="39" data-component-end-line="52" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%20lg%3Aw-auto%20max-w-%5B400px%5D%20sm%3Amax-w-%5B500px%5D%20lg%3Amax-w-%5B600px%5D%20%5Cr%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20hover%3Ascale-105%20transition-transform%20duration-300%20flex%20justify-center%22%7D"
                key={index}
                className="relative w-full lg:w-auto max-w-[400px] sm:max-w-[500px] lg:max-w-[600px] 
                           hover:scale-105 transition-transform duration-300 flex justify-center"
              >
                <Image data-component-id="src/app/PartnersSection.tsx:44:16" data-component-path="src/app/PartnersSection.tsx" data-component-line="44" data-component-end-line="51" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-full%20h-auto%20max-h-%5B120px%5D%20object-contain%20rounded-sm%22%7D"
                  src={partner.src}
                  alt={partner.alt}
                  width={partner.width}
                  height={partner.height}
                  className="w-full h-auto max-h-[120px] object-contain rounded-sm"
                  unoptimized
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// Media Partners Section (with clickable logos)
const MediaPartnersSection = () => {
const mediaPartnerImages = [
  {
    src: "/images/oursn-logo.webp",
    alt: "oursn-logo",
    href: "https://oursn.net/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/jamma-logo.webp",
    alt: "Jamma Europe",
    href: "https://www.jamma.it/tag/jamma-europe",
    width: 170,
    height: 140,
  },
  {
    src: "/images/oyungunlugu.webp",
    alt: "Oyun Günlüğü",
    href: "https://www.oyungunlugu.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/bfmtimes.webp",
    alt: "BFM Times",
    href: "https://bfmtimes.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/bitcoininsider.webp",
    alt: "Bitcoin Insider",
    href: "https://www.bitcoininsider.org/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/dgroup-black.webp",
    alt: "DGroup Capital",
    href: "https://dgroup.capital/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coinaute.webp",
    alt: "Coinaute",
    href: "https://coinaute.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/orbink.webp",
    alt: "Orbink",
    href: "https://orbink.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coinstori.webp",
    alt: "Coinstori",
    href: "https://coinstori.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/theholycoins-black.webp",
    alt: "The Holy Coins",
    href: "https://theholycoins.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/blockchainmedia.webp",
    alt: "Blockchain Media Indonesia",
    href: "https://blockchainmedia.id/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/bitcoinworld.webp",
    alt: "BitcoinWorld",
    href: "https://bitcoinworld.co.in/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/crypto-news-black.webp",
    alt: "Crypto.news",
    href: "https://crypto.news/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coinfea.webp",
    alt: "Coinfea",
    href: "https://coinfea.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/toktimes.webp",
    alt: "TokTimes",
    href: "https://toktimes.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/wikiexpo.webp",
    alt: "WikiExpo",
    href: "https://www.wikiexpo.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coin-gabbar.webp",
    alt: "CoinGabbar",
    href: "https://www.coingabbar.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/icoholder-black.webp",
    alt: "ICOholder",
    href: "https://icoholder.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/cryptoken-media.webp",
    alt: "Cryptoken Media",
    href: "https://cryptoken.media/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/cryptopolitan.webp",
    alt: "Cryptopolitan",
    href: "https://www.cryptopolitan.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/kd-wire-black.webp",
    alt: "KeyDifference",
    href: "https://keydifference.com/wire/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/block24seven.webp",
    alt: "Block24Seven",
    href: "https://block24seven.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/bdventures.webp",
    alt: "BD Ventures",
    href: "https://www.bdventures.vn/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coin-edition.webp",
    alt: "CoinEdition",
    href: "https://coinedition.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/etherpr.webp",
    alt: "EtherPR",
    href: "https://etherpr.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coinraftar.webp",
    alt: "CoinRaftar",
    href: "https://coinraftar.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coinrab.webp",
    alt: "CoinRab",
    href: "https://coinrab.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coincodex.webp",
    alt: "CoinCodex",
    href: "https://coincodex.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coincarp.svg",
    alt: "CoinCarp",
    href: "https://www.coincarp.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coincheckup.webp",
    alt: "CoinCheckup",
    href: "https://coincheckup.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/coinpaper.webp",
    alt: "Coinpaper",
    href: "https://coinpaper.com/",
    width: 170,
    height: 140,
  },
  {
    src: "/images/zex-pr-wire.webp",
    alt: "zexprwire",
    href: "https://zexprwire.com/",
    width: 170,
    height: 140,
  },
];

  return (
    <section data-component-id="src/app/PartnersSection.tsx:291:4" data-component-path="src/app/PartnersSection.tsx" data-component-line="291" data-component-end-line="333" data-component-file="PartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22media-partners%22%2C%22className%22%3A%22w-full%20bg-bg-surface%22%7D" id="media-partners" className="w-full bg-bg-surface">
  <div data-component-id="src/app/PartnersSection.tsx:292:2" data-component-path="src/app/PartnersSection.tsx" data-component-line="292" data-component-end-line="332" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1440px%5D%20mx-auto%20px-%5B10px%5D%20py-%5B20px%5D%22%7D" className="w-full max-w-[1440px] mx-auto px-[10px] py-[20px]">
    <div data-component-id="src/app/PartnersSection.tsx:293:4" data-component-path="src/app/PartnersSection.tsx" data-component-line="293" data-component-end-line="331" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B32px%5D%20sm%3Agap-%5B40px%5D%20lg%3Agap-%5B48px%5D%20justify-start%20items-center%20w-full%20max-w-%5B1146px%5D%20mx-auto%22%7D" className="flex flex-col gap-[32px] sm:gap-[40px] lg:gap-[48px] justify-start items-center w-full max-w-[1146px] mx-auto">
      
      {/* Section Header */}
      <h2 data-component-id="src/app/PartnersSection.tsx:296:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="296" data-component-end-line="298" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B24px%5D%20sm%3Atext-%5B28px%5D%20lg%3Atext-%5B31px%5D%20font-bold%20leading-%5B30px%5D%20sm%3Aleading-%5B34px%5D%20lg%3Aleading-%5B37px%5D%20text-center%20text-text-accent%20font-rubik%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="text-[24px] sm:text-[28px] lg:text-[31px] font-bold leading-[30px] sm:leading-[34px] lg:leading-[37px] text-center text-text-accent font-rubik">
   Media Partners
      </h2>

      {/* Media Partner Images */}
      <div data-component-id="src/app/PartnersSection.tsx:301:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="301" data-component-end-line="330" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20lg%3Agrid-cols-5%20gap-%5B18px%5D%20sm%3Agap-%5B22px%5D%20lg%3Agap-%5B26px%5D%20w-full%20justify-center%20items-center%20px-%5B10px%5D%20sm%3Apx-%5B20px%5D%20lg%3Apx-%5B30px%5D%22%7D" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-[18px] sm:gap-[22px] lg:gap-[26px] w-full justify-center items-center px-[10px] sm:px-[20px] lg:px-[30px]">
        
        {mediaPartnerImages.map((partner, index) => (
          <a data-component-id="src/app/PartnersSection.tsx:304:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="304" data-component-end-line="327" data-component-file="PartnersSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22w-full%20flex%20justify-center%22%7D"
            key={index}
            href={partner.href}
            target="_blank"
            rel={
              partner.href === "https://www.cryptonewsz.com/"
                ? "noopener noreferrer"
                : "noopener noreferrer nofollow"
            }
            className="w-full flex justify-center"
          >
            <div data-component-id="src/app/PartnersSection.tsx:315:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="315" data-component-end-line="326" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-%5B%23fff%5D%20rounded-lg%20shadow-%5B0px_6px_16px_%2300000014%5D%20overflow-hidden%20w-full%20max-w-%5B180px%5D%20h-%5B80px%5D%20flex%20items-center%20justify-center%20p-2%22%7D" className="bg-[#fff] rounded-lg shadow-[0px_6px_16px_#00000014] overflow-hidden w-full max-w-[180px] h-[80px] flex items-center justify-center p-2">
              
              <Image data-component-id="src/app/PartnersSection.tsx:317:14" data-component-path="src/app/PartnersSection.tsx" data-component-line="317" data-component-end-line="324" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22max-h-%5B60px%5D%20w-auto%20object-contain%22%7D"
                src={partner.src}
                alt={partner.alt}
                width={partner.width}
                height={partner.height}
                className="max-h-[60px] w-auto object-contain"
                unoptimized
              />
              
            </div>
          </a>
        ))}

      </div>
    </div>
  </div>
</section>
  );
};

// Main export combining both sections
const AllPartners = () => {
  return (
    <>
      <PartnersSection data-component-id="src/app/PartnersSection.tsx:341:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="341" data-component-end-line="341" data-component-file="PartnersSection.tsx" data-component-name="PartnersSection" data-component-content="%7B%22elementName%22%3A%22PartnersSection%22%7D" />
      <MediaPartnersSection data-component-id="src/app/PartnersSection.tsx:342:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="342" data-component-end-line="342" data-component-file="PartnersSection.tsx" data-component-name="MediaPartnersSection" data-component-content="%7B%22elementName%22%3A%22MediaPartnersSection%22%7D" />
    </>
  );
};

export default AllPartners;
